import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { PlatformEnvData, PlatformEnvDataProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { IBuilderComponentPageConfig } from './types'

export const builderComponentPageEnvDataProvider = withDependencies(
	[named(PageFeatureConfigSymbol, name)],
	(pageConfig: IBuilderComponentPageConfig): PlatformEnvDataProvider => ({
		platformEnvData: (): Partial<PlatformEnvData> => {
			const builderComponentsImportMapSdkUrls = pageConfig.moduleSpecifierToUrlMap.sdk
			const builderComponentsCompTypeSdkUrls = pageConfig.componentTypeToUrlMap.sdk

			return {
				builderComponentsImportMapSdkUrls,
				builderComponentsCompTypeSdkUrls,
			}
		},
	})
)
